import RoomType from '../roomType';
export default class SmallKitchen extends RoomType {
    constructor() {
        super();
        this.id = 'SmallKitchen';
        this.name = "Tekjøkken";
        this.icon = "mdi-coffee-outline";
        this.stateQuestions.questions.push(
            {
                'id': 'windows',
                'title': 'Vinduer og karmer',
                'active': true,
                'value': -1
            },
            {
                'id': 'fronts',
                'title': 'Fronter og skap',
                'active': true,
                'value': -1
            },
            {
                'id': 'kitchen_fan',
                'title': 'Kjøkkenvifte',
                'active': true,
                'value': -1
            },
            {
                'id': 'countertop',
                'title': 'Benkeplater',
                'active': true,
                'value': -1
            },
            {
                'id': 'fridge',
                'title': 'Kjøleskap/Fryser',
                'active': true,
                'value': -1
            },
            {
                'id': 'stove',
                'title': 'Komfyr og stekeplate',
                'active': true,
                'value': -1
            },
            {
                'id': 'dishwasher',
                'title': 'Oppvaskmaskin',
                'active': true,
                'value': -1
            },
            {
                'id': 'taps',
                'title': 'Kran og vask',
                'active': true,
                'value': -1
            },
            {
                'id': 'lighting',
                'title': 'Lamper',
                'active': true,
                'value': -1
            }
        );
        this.contentTypes.options.unshift(
            {
                'id': 'integrated',
                'title': 'Integrerte hvitevarer',
                'active': true,
                'value': -1
            },
            {
                'id': 'dishwasher',
                'title': 'Oppvaskmaskin',
                'active': true,
                'value': -1
            },
            {
                'id': 'unduction',
                'title': 'Induksjonstopp',
                'active': true,
                'value': -1
            },
            {
                'id': 'fridge',
                'title': 'Kjøle-/fryseskap',
                'active': true,
                'value': -1
            },
            {
                'id': 'micro',
                'title': 'Microbølgeovn',
                'active': true,
                'value': -1
            },
            {
                'id': 'vent',
                'title': 'Avtrekksvifte',
                'active': true,
                'value': -1
            },
            {
                'id': 'coal',
                'title': 'Kullfiltervifte',
                'active': false,
                'value': -1
            },
            {
                'id': 'wine',
                'title': 'Vinskap',
                'active': false,
                'value': -1
            },
            {
                'id': 'kaffemaskin',
                'title': 'Kaffemaskin',
                'active': false,
                'value': -1
            },
            {
                'id': 'wood_top',
                'title': 'Heltre benkeplate',
                'active': false,
                'value': -1
            },
            {
                'id': 'stone_top',
                'title': 'Benkeplate i stein',
                'active': false,
                'value': -1
            },
            {
                'id': 'island',
                'title': 'Kjøkkenøy',
                'active': false,
                'value': -1
            },
            {
                'id': 'flattened_sink',
                'title': 'Planlimt servant',
                'active': false,
                'value': -1
            },
        );
    }
}